
import { defineComponent } from 'vue';
import GuideSearch from './GuideSearch.vue';
import axios from 'axios';
import LatestNews from "./LatestNews.vue";
import { format } from 'date-fns';
import { mapActions } from 'pinia';
import { useGuideIdStore } from '@/stores/guideIdStore';

export default defineComponent({
	name: 'FrontPage',
	components: {
		GuideSearch,
		LatestNews
	},
	data() { return {
		// recentGuides: [] as any[]
	}},
	methods: {
		// getRecentGuides() {
		// 	axios.get('Guide/GetRecentGuides')
		// 		.then(resp => {
		// 			this.recentGuides = resp.data;
		// 		})
		// },
		formatDate(d: string|null) {
			if (!d) {
				return ""
			}
			if(typeof d === 'string') {
				return format(new Date(d), 'd.M.yyyy')
			}
			return format(d, 'd.M.yyyy')
		},
		goToGuide(id:number) {
			this.$router.push('/artikkeli/'+id)
		},
		attemptToNavigate(guideidentifier: string) {
			axios.get('Guide/GuideIdByIdentifier/'+guideidentifier)
				.then(resp => {
					if (resp.data) {
						this.goToGuide(resp.data);
					}
				})
				.catch(() => { console.log("no guide") })
		},
		...mapActions(useGuideIdStore, ["insert"]),
	},
	mounted() {
		this.insert(null);
	}
});
